jQuery(document).ready(function ($) {
  if (jQuery(document).width() <= 640) {
    if (jQuery('#breadcrumbs').length) {
      var breadcrumb = document.getElementById('breadcrumbs').parentElement;
      breadcrumb.scrollLeft = breadcrumb.scrollWidth;
      breadcrumb.classList.remove('hp\:opacity-0');
    }
  }
});